import http from "../http-common";
import api from "./api";
import TokenService from "./token.service";

class DocsDataService {
  getAll() {
    return http.get("/documents");
  }

  get(id) {
    return http.get(`/documents/${id}`);
  }

  create(data) {
    return http.post("/documents", data);
  }

  update(id, data) {
    return http.put(`/documents/${id}`, data);
  }

  delete(id, name) {
    return http.delete(`/documents/${id}/${name}`);
  }

  deleteAll() {
    return http.delete(`/documents`);
  }

  findByHandler(name) {
    return http.get(`/documents?name=${name}`);
  }

  // Server-filtered fetch for a specific caseId. Prefer this over getAll()+client-filter
  // Accept optional params (limit, offset, cursor, etc.) via second argument
  findByCase(caseId, opts = {}) {
    const params = Object.assign({ caseId }, opts || {});
    return http.get(`/documents`, { params });
  }

  // Request a short-lived download token for a specific document id
  getDownloadToken(id) {
    // Ensure x-access-token header is present (some build/runtime situations
    // may not have the request interceptor attached yet). Mirror upload service
    // behavior and attach token explicitly to be robust during switchover.
    // Avoid sending the JSON literal `null` as the request body because
    // Express's bodyParser.json({ strict: true }) rejects top-level
    // primitives ("null is not valid JSON"). Send an empty object instead.
    return api.post(
      `/documents/${id}/download-token`,
      {},
      {
        headers: {
          "x-access-token": TokenService.getLocalAccessToken(),
        },
      }
    );
  }
}

export default new DocsDataService();
